import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import StyledButton from "./StyledButton";
import { COLORS } from "constants/colors";

const NoticeList = ({ notices }) => {
  return (
    <Box sx={{ mt: 2 }}>
      {notices &&
        notices.length > 0 &&
        notices.map((notice, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "start",
              mb: 1,
            }}
          >
            <Typography
              sx={(theme) => ({
                fontFamily: theme.components.dialog.description.fontFamily,
                fontSize: "12px",
                lineHeight: 1.2,
                whiteSpace: "pre-line",
                color: "text.secondary",
                // textAlign: "center",
              })}
            >
              {notice}
            </Typography>
          </Box>
        ))}
    </Box>
  );
};

const WarningList = ({ warnings }) => {
  return (
    <Box sx={{ mt: 2 }}>
      {warnings &&
        warnings.length > 0 &&
        warnings.map((warning, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "start",
              mb: 1,
            }}
          >
            <Typography
              sx={(theme) => ({
                fontFamily: theme.components.dialog.description.fontFamily,
                fontSize: "12px",
                lineHeight: 1.2,
                whiteSpace: "pre-line",
                fontWeight: "bold",
                color: theme.system.colors.text.warning,
              })}
            >
              {warning}
            </Typography>
          </Box>
        ))}
    </Box>
  );
};

export default function ButtonDialog({
  open,
  title,
  url,
  description,
  content,
  notices,
  warnings,
  rawButtons = [],
  buttons = [],
  buttonNotice,
  handleClose,
  showCloseButton = true,
  paperSx,
  titleSx,
}) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: (theme) => ({
          width: theme.components.dialog.width,
          backgroundColor: theme.components.dialog.backgroundColor,
          paddingRight: "20px",
          paddingLeft: "20px",
          paddingBottom: "16px",
          borderRadius: "5px",
          boxShadow: "0px 0px 4px rgba(200, 200, 200, 0.5)",
          ...(typeof paperSx === "function" ? paperSx(theme) : paperSx),
        }),
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.8)", // ← デフォルトより濃くする
        },
      }}
    >
      <DialogTitle
        sx={{
          position: "relative",
          mb: "18px",
        }}
      >
        {showCloseButton && ( // 追加: 表示制御
          <IconButton
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              top: "8px",
              right: "8px",
              color: theme.components.dialog.button.color,
            })}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={(theme) => ({
            ...theme.components.dialog.title,
            lineHeight: 1.6,
            whiteSpace: "pre-line",
            textAlign: "center",
            fontWeight: "bold",
            ...(typeof titleSx === "function" ? titleSx(theme) : titleSx),
          })}
        >
          {title}
        </Typography>

        <Typography
          sx={(theme) => ({
            ...theme.components.dialog.description,
            lineHeight: 1.5,
            whiteSpace: "pre-line",
            textAlign: "center",
            mt: 2,
          })}
        >
          {description}
        </Typography>

        {content}

        {url && (
          <Link href={url} target="_blank" rel="noopener">
            {url}
          </Link>
        )}

        <NoticeList notices={notices} />
        <WarningList warnings={warnings} />
        <Box
          sx={{
            display: "flex",
            gap: 3,
            mt: 4,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {rawButtons.map((button, index) => button)}
          {buttons.map((button, index) => (
            <StyledButton
              key={index}
              variant="contained"
              disabled={button.disabled}
              onClick={button.onClick}
              sx={(theme) => ({
                ...theme.components.dialog.button,
                width: "100%",
              })}
            >
              {button.label}
            </StyledButton>
          ))}
          {buttonNotice && (
            <Typography
              sx={{
                fontSize: "12px",
                lineHeight: 1.2,
                whiteSpace: "pre-line",
                color: COLORS.TEXT_BLACK,
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              {buttonNotice}
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
